import { useEffect, useRef } from 'react';
import { adsConfig } from '../config';

declare global {
  interface Window { adsbygoogle?: unknown[] }
}

let scriptInjected = false;
function ensureScript() {
  if (scriptInjected || !adsConfig.enabled) return;
  scriptInjected = true;
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsConfig.client}`;
  s.crossOrigin = 'anonymous';
  document.head.appendChild(s);
}

/**
 * A clearly labelled, non-intrusive display ad. Only used on content pages
 * (home, effect library) and below a finished export — never inside the editor
 * workspace, preview, timeline, effect controls, or while exporting.
 */
export function AdSlot({ slot, label = 'Advertisement' }: { slot: 'home' | 'library' | 'export'; label?: string }) {
  const ref = useRef<HTMLModElement>(null);
  const slotId = adsConfig.slots[slot];
  const live = adsConfig.enabled && !!slotId;

  useEffect(() => {
    if (!live) return;
    ensureScript();
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      /* Ad blocked or failed: the page works the same without it. */
    }
  }, [live]);

  if (!live) {
    if (!adsConfig.showPlaceholders) return null;
    return (
      <aside className="ad-slot ad-slot--placeholder" aria-label="Ad placeholder">
        <span>{label} placeholder — ads are disabled in this build</span>
      </aside>
    );
  }
  return (
    <aside className="ad-slot" aria-label={label}>
      <div className="ad-slot__label">{label}</div>
      <ins
        ref={ref}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={adsConfig.client}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </aside>
  );
}
